/* -------------------------------------------

	Name:		Theme+
	Date:		2021/11/01

---------------------------------------------  */
/*global document, window, yall, setTimeout, Swiper, createElementWithClass, createRatingsHtmlElement, Cookies, semanticTabs, Image, Shopify, Event */
/*//jshint esversion: 6 */

/*function childrenMatches(elem, callback) {
	return Array.from(elem.children).filter(callback);
}*/

/**
 * Changes made:
 * - removed some"global" variables that were declared right after document.addEventListener('DOMContentLoaded', ....) and moved them inside methods that are using it
 * - instead of using window.open, change <a> tag to add noopener and target as _blank
 * - renamed variable of to _of on scrolling method (avoid using javascript keywords for variable names as best practice)
 * - comments in some functions
 * - removed i var for loops and added inside for loop (it's super hard to visually debug what the value of i will be when using like that)
 * - action and test required on @02, @03
 * - replaced all keyCode to key - https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
 * - @04 the function is super big (and some other in the code too)
 */

var html_tag = document.documentElement,
	// i = 0, -> moved to be inside of for()
	img_lazy = document.querySelectorAll('img[data-src]:not(.dont), picture[data-srcset]:not(.dont)'),
	isMobile = false,
	// global_dir,
  i;
for (i = 0; i < img_lazy.length; i = i + 1) {
	img_lazy[i].classList.add('lazy');
	if (!img_lazy[i].hasAttribute('src')) {
		img_lazy[i].setAttribute('src', img_lazy[i].getAttribute('data-src'));
	}
}
function isTouchDevice() {
	if (window.matchMedia("(pointer: coarse)").matches) {
		return true;
	} else {
		return false;
	}
}
if (window.mobileCheck() || isTouchDevice()) {
	isMobile = true;
}

/*if (html_tag.hasAttribute('data-theme')) {
	html_tag.setAttribute('data-theme-js', html_tag.getAttribute('data-theme'));
	html_tag.removeAttribute('data-theme');
}*/

var listCollectionSliderEvt = new CustomEvent("listCollectionSlider"),
    announcementSliderEvt = new CustomEvent("announcementSlider"),
    moduleFeaturedSliderEvt = new CustomEvent("moduleFeaturedSlider"),
    listProductSliderEvt = new CustomEvent("listProductSlider"),
		listUspSliderEvt = new CustomEvent("listUspSlider"),
    listTestimonialsSliderEvt = new CustomEvent("listTestimonialsSlider"),
    listStaticSliderEvt = new CustomEvent("listStaticSlider"),
		searchClassesEvt = new CustomEvent("searchClasses"),
		createColsEvt = new CustomEvent("createCols"),
		moduleTabsEvt = new CustomEvent("moduleTabs"),
    formZindexEvt = new CustomEvent("formZindex"),
		ratingsEvt = new CustomEvent("ratings"),
    inputPaddingEvt = new CustomEvent("inputPadding"),
    checkLogoHeightEvt = new CustomEvent("checkLogoHeight"),
	backgroundEvt = new CustomEvent("background");

/**
 * Close dropdown element
 * @param {HTMLElement} element Parent element that receives the aria-expanded attribute
 */
function toggle_dropdowns_simple(el) {
	'use strict';
	if (el.classList.contains('toggle')) {
		el.classList.remove('toggle');
		//el.parentElement.setAttribute('aria-expanded', false);
	} else {
		el.classList.add('toggle');
		//el.parentElement.setAttribute('aria-expanded', true);
	}
}


function append_url(el, content, className, href, access) {
	'use strict';
	var link = createElementWithClass('a', className);
	if (href) {
		link.href = href;
	} else {
		link.href = './';
	}
	if (access === true) {
		link.setAttribute('tabindex', -1);
		link.setAttribute('aria-hidden', true);
		link.setAttribute('focusable', false);
	}
	link.innerHTML += content;
	el.appendChild(link);
}

function wrap(el, wrapper, className) {
	'use strict';
	el.parentNode.insertBefore(wrapper, el);
	if (className) {
		wrapper.classList.add(className);
	}
	wrapper.appendChild(el);
}

function new_css(id, href, media) {
	"use strict";
	if (!document.getElementById(id)) {
		var a = document.createElement('link'),
			b = document.querySelectorAll('link[id]');
		if (media === undefined) {
			media = 'screen';
		}
		a.setAttribute('id', id);
		a.setAttribute('rel', 'stylesheet');
		a.setAttribute('href', href);
		a.setAttribute('media', media);
		a.setAttribute('id', id);

		//if (async = true && b) {
		if (b.length) {
			Array.from(b).forEach(function (el) {
				el.after(a);
			});
		} else {
			document.head.appendChild(a);
		}
	}
}

var root_styles = document.querySelector(':root');

function getScrollbarWidth() {
	root_styles.style.setProperty('--scrollbar_width', window.innerWidth - html_tag.clientWidth + 'px');
}
getScrollbarWidth();

function create_slider(el, settings, minSlides) {
	'use strict';
	var sliderElement = el,
		divContent,
		items,
		paginationClass,
		dots,
		dots_cont,
    //fr_cont,
		prev,
		next;

	if (el.children.length > 1) {
    //new_css('css-swiper', '//sharkrobot.com/cdn/shop/t/58/assets/async-swiper.css?v=111603181540343972631784050599');
		// if swiper element is <ul>, convert it to <div> and all it's children from <li> to <div class="li">
		if (el.tagName.toLowerCase() === "ul") {
			Array.from(el.children).forEach(function (child) {
				var addClass = 'li',
					divLi;
				//Array.from(el.children).forEach(child => {
				if (child.hasAttribute('class')) {
					addClass = 'li ' + child.getAttribute('class');
				}

				divLi = document.createElement("div");
				divLi.className = addClass;
				divLi.innerHTML = child.innerHTML;
				child.parentNode.replaceChild(divLi, child);
			});

			divContent = document.createElement('div');
			divContent.className = el.getAttribute('class');
			divContent.innerHTML = el.innerHTML;
			if (el.hasAttribute('data-random')) {
				divContent.setAttribute('data-random', el.getAttribute('data-random'));
			}
			el.parentNode.replaceChild(divContent, el);
			sliderElement = divContent;
		}

		items = sliderElement.children;

		if (!minSlides) {
			minSlides = 1;
		}
		if (items.length > parseFloat(minSlides)) {
			// if pagination class is different from default value (swiper-pagination), creates pagination element with correct class
			paginationClass = (settings && settings.pagination && settings.pagination.el) || ".swiper-pagination";
			paginationClass = paginationClass.replace(/\./g, " ").trim();

      /*if (paginationClass === 'swiper-pagination-null') {
				paginationClass === 'swiper-pagination';
			}*/

			dots = createElementWithClass('span', paginationClass);
			prev = createElementWithClass('span', 'swiper-button-prev');
			next = createElementWithClass('span', 'swiper-button-next');
			sliderElement.classList.add('s4wi');
      //console.log(paginationClass)

			//prev.classList.add('swiper-id-'+randomID);
			//next.classList.add('swiper-id-'+randomID);

			Array.from(items).forEach(function (el) {
				wrap(el, document.createElement('div'), 'swiper-slide');
			});
			sliderElement.innerHTML = '<div class="swiper-outer"><div class="swiper-wrapper">' + sliderElement.innerHTML + '</div></div> <div class="swiper-custom-pagination"></div>';
			dots_cont = sliderElement.getElementsByClassName('swiper-custom-pagination')[0];
			// this fixed the bug that when adding the swiper in the top, the pagination for the main swiper wasn't being created
      if (settings && settings.pagination) {
				settings.pagination.el = settings.pagination.el || "." + paginationClass;
				dots_cont.appendChild(prev);
				dots_cont.appendChild(dots);
				//dots_cont.appendChild(fr_cont);
				dots_cont.appendChild(createElementWithClass('span', 'swiper-custom-fraction'));
				//dots_cont.appendChild(createElementWithClass('span', 'swiper-custom-fraction-wrapper'));
				dots_cont.appendChild(next);
				//fr2 = dots_cont.getElementsByClassName('swiper-custom-fraction-wrapper')[0];
				//fr2.appendChild(createElementWithClass('span', 'swiper-button-prev'));
				//fr2.appendChild(createElementWithClass('span', 'swiper-custom-fraction'));
				//fr2.appendChild(createElementWithClass('span', 'swiper-button-next'));

			} else {
				sliderElement.appendChild(prev);
				sliderElement.appendChild(next);
			}

			return new Swiper(sliderElement.children[0], settings);
		}
	}

	return null;
}

function clone_with_class(el, cl1, cl2) {
	'use strict';
	var cln = el.cloneNode(true);
	cln.classList.add(cl1);
	el.after(cln);
	el.classList.add(cl2);
}

function randomize(el) {
	'use strict';
	//el.setAttribute('data-random', Math.floor(Math.random() * (9999 - 0 + 1)) + 0);
	el.setAttribute('data-random', Math.floor(Math.random() * 10000) + 1);
}

function new_js(el) {
	'use strict';
	var tag = document.createElement('script');
	tag.src = el;
	document.body.appendChild(tag);
}

// Prevent scroll down page when SPACE is pressed in a focused element but BODY, INPUT, SELECT or TEXTAREA
window.onkeydown = function (e) {
	'use strict';
	/*var e = e || window.event,
		target = e.srcElement || e.target,*/
	var f = e || window.event,
		target = f.srcElement || f.target,
		tagName = target.tagName.toLowerCase();
	if (e.key === ' ') {
		// if it's input, allow to perform the action (add space to text)
		if (['body', 'input', 'textarea', 'select'].includes(tagName)) {
			return true;
		} else {
			return false;
		}
	}
	return true;
};
function isTouchDevice() {
	if (window.matchMedia("(pointer: coarse)").matches) {
		return true;
	} else {
		return false;
	}
}

// Check if image is light or dark
/*function getImageLightness(imageSrc, callback) {
	var img = document.createElement("img");
	img.src = imageSrc;
	img.style.display = "none";
	document.body.appendChild(img);

	var colorSum = 0;

	img.onload = function () {
		// create canvas
		var canvas = document.createElement("canvas");
		canvas.width = this.width;
		canvas.height = this.height;

		var ctx = canvas.getContext("2d");
		ctx.drawImage(this, 0, 0);

		var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		var data = imageData.data;
		var r, g, b, avg;

		for (var x = 0, len = data.length; x < len; x += 4) {
			r = data[x];
			g = data[x + 1];
			b = data[x + 2];

			avg = Math.floor((r + g + b) / 3);
			colorSum += avg;
		}

		var brightness = Math.floor(colorSum / (this.width * this.height));
		callback(brightness);
	};
}*/

/*var list_featured = document.getElementsByClassName('l4ft');
if (list_featured.length) {
	loadRes(path_js + 'plugin-masonry.js', function () {
		"use strict";
		Array.from(list_featured).forEach(function (el) {
			if (el.classList.contains('cols')) {
				el.classList.add('masonry-initialized');
				var msnry = new Masonry(el, {
					itemSelector: 'li',
					originLeft: global_dir[1],
					percentPosition: true
				});
			}
		});
	}, 'masonry-loaded');
}*/

function checkIfImageExists(url, callback) {
	'use strict';
	const img = new Image();
	img.src = url;

	if (img.complete) {
		callback(true);
	} else {
		img.onload = () => {
			callback(true);
		};

		img.onerror = () => {
			callback(false);
		};
	}
}

document.addEventListener('DOMContentLoaded', function () {
	'use strict';
  yall({
		observeChanges: true,
		threshold: 500
		/*,
				events: {
					load: function (event) {
						if (!event.target.classList.contains("lazy") && event.target.tagName.toLowerCase() === 'img') {
							event.target.classList.add("yall-loaded");
						}
					}
				}*/
	});
	var // i = 0,
    	//background_id,
      header_id,
      footer_id = document.getElementById('shopify-section-footer'),
      // path_css = 'styles/',
      content_id = document.getElementById('content'),
      logo_id = document.getElementById('logo'), nav_main,
		nav_id = document.getElementById('nav'),
		nav_bar_id = document.getElementById('nav-bar'),
		search_id = document.getElementById('search'),
      top_bar,
  		//root_id,
      // a_dark,
      //img_overlay,
      //nav_id = document.getElementById('nav'),
      //nav_user_id = document.getElementById('nav-user'),
      //nav_top_id = document.getElementById('nav-top'),
      //header_id = document.getElementById('header'),

		Default = {
			utils: {
				start: function () {
					html_tag.classList.add('js');
				},
				links: function () {
					// Force external link to open in the new tab
					/*var a_tag_external = document.querySelectorAll('a[rel*="external"]');
					if (a_tag_external.length) {
						Array.from(a_tag_external).forEach(function (el) {
							// removed window.open() and added noopener as best practice to <a> tags
							// https://developer.mozilla.org/en-US/docs/Web/API/Window/open#avoid_resorting_to_window.open
							var relAttribute = (el.getAttribute('rel') || '').split(' '), targetAttribute;
							if (!relAttribute.includes('noopener')) {
								relAttribute.push('noopener');
							}
							el.setAttribute('rel', relAttribute.join(' '));

							// add target to it - https://developer.mozilla.org/en-US/docs/Web/API/Window/open#offer_to_open_a_link_in_a_new_window_using_these_guidelines
							// although this won't work because when use noopener, it will automatically set target to _blank
							targetAttribute = el.getAttribute('target');
							if (!targetAttribute) {
								targetAttribute = 'external';
							}
							el.setAttribute('target', targetAttribute);
						});
					}*/
					/*function removeDark() {
						var dark_mode = document.getElementById('dark-mode-css');
						if (dark_mode) {
							dark_mode.remove();
						}
						html_tag.classList.remove('t1dr');
						Cookies.set('dark', 'no');
					}*/

					// Toggle dark mode
					/*var a_dark = document.getElementsByClassName('link-dark');
					if (a_dark.length) {
						Array.from(a_dark).forEach(function (el) {
							if (el.tagName.toLowerCase() === 'a') {
								el.addEventListener('click', function (e) {
									if (html_tag.classList.contains('t1dr')) {
										html_tag.classList.add('t1lt');
										// removeDark();
									} else {
										new_css('dark-mode-css', '//sharkrobot.com/cdn/shop/t/58/assets/theme-dark.css?v=163303971527085652071784050599');
										html_tag.classList.add('t1dr');
										html_tag.classList.remove('t1ac', 't1lt');
										Cookies.set('dark', 'yes');
									}
									e.preventDefault();
								});
							}
						});
					}
					if (Cookies.get('dark') === 'yes') {
						new_css('dark-mode-css', '//sharkrobot.com/cdn/shop/t/58/assets/theme-dark.css?v=163303971527085652071784050599');
						html_tag.classList.add('t1dr');
						html_tag.classList.remove('t1ac', 't1lt');
						Cookies.remove('accessible');
					} else {
						html_tag.classList.add('t1lt');
						// removeDark();
					}*/
					var breadcrumb_back = document.querySelectorAll('.breadcrumb-back');
					if (breadcrumb_back.length) {
						Array.from(breadcrumb_back).forEach(function (el) {
							if (document.referrer.indexOf(window.location.host) !== -1) {
								el.addEventListener('click', function (e) {
									history.go(-1); return false;
								})
							}
							else { el.remove(); }
						})
					}

				},
				mails: function () {
					// Convert email//domain/com to actual email address
					var email_tag = document.getElementsByClassName('email');
					if (email_tag.length) {
						Array.from(email_tag).filter(function (el) {
							return el.tagName.toLowerCase() !== 'input' && el.tagName.toLowerCase() !== 'div';
						}).forEach(function (el) {
							el.innerHTML = el.innerHTML.replace('//', '@');
							if (el.tagName.toLowerCase() === 'a') {
								el.setAttribute('href', 'mailto:' + el.innerText);
							}
						});
					}
				},
				forms: function () {
					var form_children, select_tag = document.getElementsByTagName('select');
          window.addEventListener("formZindex", function (evt) {
			  // Assign z-indexes to form elements
			  // :placeholder-like support for <select> element
			  if (select_tag.length) {
				  Array.from(select_tag).forEach(function (el) {
					  el.parentNode.classList.add('has-select');
					  if (el.closest('p') !== null) {
						  el.closest('p').classList.add('has-select');
					  }
					  el.addEventListener('change', function () {
						  el.classList.add('changed');
					  });
				  });
			  }

			  form_children = document.querySelectorAll('form > *, fieldset > *, .no-zindex, .no-zindex > *, .has-select, .f8pr > *');
			  if (form_children.length) {
				  Array.from(form_children).forEach(function (el, index) {
					  el.style.zIndex = form_children.length - index;
				  });
			  }
          });
          window.dispatchEvent(formZindexEvt);

					// :placeholder-like support for <select> element
					select_tag = document.getElementsByTagName('select');
					if (select_tag.length) {
						Array.from(select_tag).forEach(function (el) {
							el.addEventListener('change', function () {
								el.classList.add('changed');
							});
						});
					}

          window.addEventListener("inputPadding", function (evt) {
            var input_prefix, input_suffix;
            // Padding for ".input-prefix" element
            input_prefix = document.querySelectorAll('.input-prefix > span:first-child');
            if (input_prefix.length) {
              Array.from(input_prefix).forEach(function (el) {
                var c = el.nextElementSibling;
                if (el.offsetWidth != 0) {
                  if (html_tag.getAttribute('dir') === 'rtl') {
                    c.style.paddingRight = el.offsetWidth + 'px';
                  } else {
                    c.style.paddingLeft = el.offsetWidth + 'px';
                  }
                }
              });
            }
            // Padding for ".input-suffix" element
            input_suffix = document.querySelectorAll('.input-suffix > span:first-child');
            if (input_suffix.length) {
              Array.from(input_suffix).forEach(function (el) {
                var c = el.nextElementSibling;
                if (html_tag.getAttribute('dir') === 'rtl') {
                  c.style.paddingLeft = el.offsetWidth + 'px';
                } else {
                  c.style.paddingRight = el.offsetWidth + 'px';
                }
              });
            }
          });
					setTimeout(function () {
            window.dispatchEvent(inputPaddingEvt);
					}, 500);
				},
				top: function () {
          window.addEventListener("checkLogoHeight", function(evt) {
            search_id = document.getElementById('search');
            logo_id = document.getElementById('logo');
			nav_id = document.getElementById('nav');
			nav_bar_id = document.getElementById('nav-bar');
            function checkLogoHeight(el) {
              if (search_id && search_id.classList.contains('text-center-sticky') && (!search_id.classList.contains('compact') || search_id.classList.contains('compact-mobile'))) {
  							var header_outer_id = document.getElementById('header-outer'),
  								linkBtnInHeader = header_outer_id.querySelectorAll('.link-btn:not(.hidden)')[0];
  							if (header_outer_id) {
  								if (linkBtnInHeader !== undefined) {
  									logo_id.style.maxWidth = 0.5 * (header_outer_id.clientWidth - search_id.offsetWidth) - linkBtnInHeader.clientWidth + 'px';
  									logo_id.classList.add('super-small');
  								} else {
  									logo_id.style.maxWidth = 0.5 * (header_outer_id.clientWidth - search_id.offsetWidth) + 'px';
  								}
  							}
  						}
  						Array.from(el).forEach(function (el) {
  							if (el.clientHeight > el.parentNode.clientHeight) {
                  header_id = document.getElementById('shopify-section-header');
  								el.classList.add('long-text');
  								el.closest('#logo').classList.add('has-long-text');
                  header_id.classList.add('has-long-text');
  							}
  						});
  					}

    				if (logo_id) {
              var logo_text = logo_id.querySelectorAll('span');
    					Array.from(logo_id.querySelectorAll('img[alt]')).forEach(function (el) {
    						var pt = el.parentNode,
    							span;

    						checkIfImageExists(el.getAttribute('src'), (exists) => {
    							if (!exists) {
    								span = document.createElement('span');
    								span.innerHTML = el.getAttribute('alt');
    								pt.appendChild(span);
    								pt.classList.add('broken-img');
    							}
    						});
    					});

    					setTimeout(function () {
    						checkLogoHeight(logo_text);
							if (logo_id.classList.contains('logo-text')) {
								logo_id.classList.remove('logo-text');
							}
    					}, 100);
    					window.addEventListener('resize', function () {
    						checkLogoHeight(logo_text);
    					});
    				}

			  /// Expandable nav
			  if (nav_id) {
				  nav_main = nav_id;
			  }
			  if (nav_bar_id) {
				  nav_main = nav_bar_id;
			  }

			  function countNavDist(el, em) {
				  var el_off, el_tr = 0,
					  d, f;
				  d = el.dataset.copy,
					  f = nav_main.querySelectorAll('.show-all li[data-copy="' + d + '"]')[0];

				  if (el.classList.contains('temp-hidden')) {
					  el.classList.remove('temp-hidden');
					  if (typeof f !== 'undefined') {
						  f.classList.remove('temp-hidden');
					  }
				  }

				  if (html_tag.getAttribute('dir') === 'rtl') {
					  el_off = nav_main.clientWidth - el.offsetLeft - el.clientWidth;
				  } else {
					  el_off = el.offsetLeft;
				  }
				  if (el.parentElement.querySelectorAll('.temp-hidden:not(.show-all)').length > 0) {
					  el_tr = 1.2;
				  }

				  if (nav_main.clientWidth < el_off + el.clientWidth + em * el_tr) {
					  el.classList.add('temp-hidden');
					  if (typeof f !== 'undefined') {
						  f.classList.add('temp-hidden');
					  }
				  } else {
					  el.classList.remove('temp-hidden');
					  if (typeof f !== 'undefined') {
						  f.classList.remove('temp-hidden');
					  }
				  }
			  }

			  function countNavDistF(el, em, en) {
				  if (el.clientWidth > nav_main.clientWidth) {
					  if (nav_main.classList.contains('text-center')) {
						  nav_main.classList.remove('text-center');
						  nav_main.classList.add('have-text-center');
					  }
					  html_tag.classList.add('has-long-nav');
					  if (em.length) {
						  en = em[0].clientWidth;
					  }
					  Array.from(el.children).forEach(function (eo) {
						  countNavDist(eo, en);
						  window.addEventListener('resize', function () {
							  countNavDist(eo, en);
						  });
					  });
				  } else {
					  html_tag.classList.remove('has-long-nav');
					  if (nav_main.classList.contains('have-text-center')) {
						  nav_main.classList.add('text-center');
					  }
				  }
			  }
			  if (nav_id || nav_bar_id) {
				  var nmu = nav_main.querySelectorAll('[data-type]')[0],
					  nml = nmu.querySelectorAll('li.show-all'),
					  nms = 0,
					  nmt,
					  all_submenu;

				  Array.from(nmu.children).forEach(function (el, index) {
					  el.setAttribute('data-copy', nmu.children.length - index);
				  });

				  if (nml.length) {
					  all_submenu = createElementWithClass('ul', 'show-all-submenu');
					  nml[0].appendChild(all_submenu);
					  nmt = nml[0].closest('ul').children;
					  Array.from(nmt).forEach(function (el) {
						  "use strict";
						  var clone_me = el.cloneNode(true);
						  nml[0].querySelectorAll('.show-all-submenu')[0].appendChild(clone_me);
					  });

					  countNavDistF(nmu, nml, nms);
					  setTimeout(function () {
						  countNavDistF(nmu, nml, nms);
					  }, 100);
					  window.addEventListener('resize', function () {
						  html_tag.classList.add('has-long-nav');
						  countNavDistF(nmu, nml, nms);
					  });
				  }
			  }
          });
          window.dispatchEvent(checkLogoHeightEvt);
					// Searchbox
					window.addEventListener("searchClasses", function(evt) {
						search_id = document.getElementById('search');
						if (search_id && search_id.classList.contains('compact')) {
							//if ((!html_tag.classList.contains('t1sr-desktop')) || (!html_tag.classList.contains('t1sr-mobile'))) {
							//html_tag.classList.add('t1sr');
							//}*/
							if (search_id.classList.contains('compact-desktop')) {
								html_tag.classList.add('t1sr-desktop');
							} else if (search_id.classList.contains('compact-mobile')) {
								html_tag.classList.add('t1sr-mobile');
							} else {
								html_tag.classList.add('t1sr');
							}
							if (search_id.classList.contains('text-center-sticky')) {
								html_tag.classList.add('search-compact-is-centered');
							}
						}
					});
					window.dispatchEvent(searchClassesEvt);
				},
				footer: function () {
					// Togglable headers on mobile
					if (footer_id) {
						Array.from(footer_id.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach(function (el) {
							append_url(el, 'Close', 'header-toggle');
							el.querySelector('a.header-toggle').addEventListener('click', function (e) {
								toggle_dropdowns_simple(el.parentElement);
								e.preventDefault();
							});
						});
					}
					window.addEventListener("background", function(evt) {
			  			// Change the position of background element (just for security)
						if (document.querySelector('#background.done')) {
							document.querySelector('#background.done').remove();
						}
						var background_id = document.getElementById('background');
						if (background_id && !background_id.classList.contains('static') && (background_id.parentNode.id === 'content' || background_id.parentNode.classList.contains('shopify-section'))) {
							document.getElementById('root').appendChild(background_id);
							background_id.classList.add('done');
						}
					});
					window.dispatchEvent(backgroundEvt);
				},
				mobile: function () {
					if (isMobile) {
						html_tag.classList.add('mobile');
					} else {
						html_tag.classList.add('no-mobile');
					}
				},
				done: function () {
					new_js("//sharkrobot.com/cdn/shop/t/58/assets/scripts-async.js?v=87124554160434320861784050986");
				},
				ratings: function () {
				  window.addEventListener("ratings", function(evt) {
					  var rating_element = document.querySelectorAll('[data-val][data-of]:not(.rating-initialized)');
					  if (rating_element.length) {
						  Array.from(rating_element).forEach(function (el) {
							  var reviewsElem = createElementWithClass('span', 'rating-label'),
								  reviews = el.innerHTML,
								  rating = el.dataset.val,
								  total = el.dataset.of;
							  if (!el.classList.contains('s1br')) {
								  el.innerHTML = '';
								  el.append(createRatingsHtmlElement(rating, total));
								  reviewsElem.innerHTML = reviews;
							  } else {
								  reviewsElem.innerHTML = '<span class="bar" style="width: ' + rating / total * 100 + '%;"></span>';
							  }
							  el.appendChild(reviewsElem);
							  el.classList.add('rating-initialized');
						  });
					  }
				  });
				  window.dispatchEvent(ratingsEvt);
				},
        backgrounds: function () {
          var align_middle = document.getElementsByClassName('align-middle'),
						  align_center = document.getElementsByClassName('align-center');
					if (align_middle.length) {
						Array.from(align_middle).forEach(function (el) {
							var em = el.parentNode,
								en = em.parentNode;
							if ((el.previousElementSibling === null && el.nextElementSibling === null && em.id === 'content') || (el.previousElementSibling === null && el.nextElementSibling === null && em.previousElementSibling === null && em.nextElementSibling === null && en.id === 'content')) {
								document.getElementById('content').classList.add('align-center');
							}
						});
					}
					if (align_center.length) {
						Array.from(align_center).forEach(function (el) {
							var em = el.parentNode,
								en = em.parentNode;
							if ((el.previousElementSibling === null && el.nextElementSibling === null && em.id === 'content') || (el.previousElementSibling === null && el.nextElementSibling === null && em.previousElementSibling === null && em.nextElementSibling === null && en.id === 'content')) {
								document.getElementById('content').classList.add('align-center-static');
							}
						});
					}
					/*var list_featured_img = document.querySelectorAll('.l4ft img');
					Array.from(list_featured_img).forEach(function (el) {
						getImageLightness(el.getAttribute('src'), function (brightness) {
							if (brightness > 180) {
								el.closest('li').classList.add('bg-light');
							} else {
								el.closest('li').classList.add('bg-dark');
							}
						});
					});*/
				},
				tabs: function () {
					// Create tabs
					// Create tabs
					window.addEventListener("moduleTabs", function(evt) {
            if (content_id) {
  						var module_tabs = content_id.getElementsByClassName('m6tb');
  						if (module_tabs.length) {
  							/*loadRes(path_js + 'plugin-tabs.js', function () {
  								"use strict";*/
  							Array.from(module_tabs).forEach(function (el) {
  								if (typeof semanticTabs === 'function' /*&& typeof semanticTabs !== 'undefined'*/ && !el.classList.contains('tabs-initialized')) {
  									semanticTabs(el);
  								}
  								el.classList.add('tabs-initialized');
  							});
  							//linkMore();
  							//}, 'tabs-loaded');
  						}
            }
					});
					window.dispatchEvent(moduleTabsEvt);
				},
				swipers: function () {
          var module_featured, list_panel_slider, list_testimonials, list_static, list_usp, popup_a, list_collection_slider, module_collection, list_product_slider, data_update_product_slider, autoplay_top_int;
          window.addEventListener("moduleFeaturedSlider", function(event) {
  					module_featured = document.querySelectorAll('.m6fr:not(.s4wi)');
  					if (module_featured.length) {
  						Array.from(module_featured).forEach(function (el) {
								var pagination_type = 'bullets',
									autoplay_int = false,
									total_sl = el.children.length,
                  featuredSlider;
								if (el.classList.contains('slider-fraction')) {
									pagination_type = 'fraction';
								}
                if (el.getAttribute('data-autoplay')) {
  								autoplay_int = {
  									delay: parseFloat(el.getAttribute('data-autoplay')),
									pauseOnMouseEnter: true
									/*,disableOnInteraction: false*/
  								};
  							}
  							randomize(el);
  							//var swiper_new = create_slider(el, {
  							featuredSlider = create_slider(el, {
                  direction: 'horizontal',
  								loop: true,
  								autoHeight: true,
								resizeObserver: true,
  								lazy: {
  									loadPrevNext: true,
                    loadOnTransitionStart: true
  								},
                  autoplay: autoplay_int,
								threshold: 50,
  								pagination: {
  									el: '.swiper-pagination-' + el.getAttribute('data-random'),
                    //el: el.getElementsByClassName('swiper-pagination-bullets')[0],
  									clickable: true,
										type: pagination_type
  								},
  								navigation: {
  									nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
  									prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
  								},
								on: {
									slideChangeTransitionStart: function (swiper) {
										Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(function (em) {
											em.parentNode.classList.add('has-aside');
										});
										var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article')[0];
										if (typeof active_content !== 'undefined') {
											el.setAttribute('data-active-content', active_content.getAttribute('class'));
										}
										if (swiper.realIndex > 0) {
											el.classList.add('changed');
										} else {
											el.classList.remove('changed');
										}
										if (swiper.realIndex + 1 === total_sl) {
											el.classList.add('last-slide-active');
										} else {
											el.classList.remove('last-slide-active');
										}
									},
									resize: function (swiper) {
										// html_tag.classList.add('resized');
										if (typeof Shopify !== 'undefined' && Shopify.designMode) {
											Array.from(featuredSlider.slides).forEach(function () {
											  featuredSlider.slideNext(0);
											});
										}
										setTimeout(function () {
											featuredSlider.updateAutoHeight();
										}, 500);

									}
								}

                });
							  if (featuredSlider !== null) {
								  if (el.getAttribute('data-autoplay') && !el.classList.contains('no-controls')) {
									  append_url(el, 'Play/Pause', 'play-pause');
									  el.getElementsByClassName('play-pause')[0].addEventListener('click', function (e) {
										  if (el.classList.contains('paused')) {
											  el.classList.remove('paused');
											  featuredSlider.autoplay.start();
										  } else {
											  el.classList.add('paused');
											  featuredSlider.autoplay.stop();
										  }
										  e.preventDefault();
									  });
								  }
								  el.addEventListener('mouseleave', function () {
									  if (el.getAttribute('data-autoplay') && !el.classList.contains('paused')) {
										  el.classList.remove('paused');
										  featuredSlider.autoplay.start();
									  }
								  });
								  /*el.getElementsByClassName('play-pause')[0].addEventListener('click', function (e) {
                                      if (el.classList.contains('paused')) {
                                          el.classList.remove('paused');
                                      } else {
                                          el.classList.add('paused');
                                      }
                                  });*/
								  window.addEventListener('resize', function (event) {
									  html_tag.classList.add('resized');
								  }, true);
								  setTimeout(function () {
									  featuredSlider.updateAutoHeight();
								  }, 500);
							  }
                if (el.classList.contains('s4wi')) {
  					setTimeout(function () {
                		if (typeof updateSlidersEvt != 'undefined') {
                	      window.dispatchEvent(updateSlidersEvt);
                     }
  				 	}, 300);
  				 }
  						});
  					}
          });
          window.dispatchEvent(moduleFeaturedSliderEvt);

          window.addEventListener("announcementSlider", function(event) {
            top_bar = document.querySelector('#shopify-section-announcement-bar:not(.s4wi)');
  					if (top_bar && top_bar.children.length > 1) {
  						autoplay_top_int = false;
  						if (top_bar.getAttribute('data-autoplay')) {
  							autoplay_top_int = {
  								delay: parseFloat(top_bar.getAttribute('data-autoplay')),
								pauseOnMouseEnter: true,
								disableOnInteraction: false
  							};
  						}
              if (top_bar.getElementsByClassName('no-nav').length) {
  							top_bar.classList.add('no-nav');
  						}
  						randomize(top_bar);
  						create_slider(top_bar, {
  							direction: 'horizontal',
  							loop: true,
  							autoHeight: true,
  							lazy: {
  								loadPrevNext: true
  							},
  							autoplay: autoplay_top_int,
  							pagination: false,
  							navigation: {
  								nextEl: '[data-random="' + top_bar.getAttribute('data-random') + '"] .swiper-button-next',
  								prevEl: '[data-random="' + top_bar.getAttribute('data-random') + '"] .swiper-button-prev'
  							}
  						});
  					}
          });
          window.dispatchEvent(announcementSliderEvt);

					list_panel_slider = document.getElementsByClassName('l4ps');
					if (list_panel_slider.length) {
						Array.from(list_panel_slider).forEach(function (el) {
							var pagination_type = 'bullets',
								autoplay_int = false,
								total_sl = el.children.length;
							if (el.classList.contains('slider-fraction')) {
								pagination_type = 'fraction';
							}
							if (el.getAttribute('data-autoplay')) {
								autoplay_int = {
									delay: parseFloat(el.getAttribute('data-autoplay')),
									pauseOnMouseEnter: true,
									disableOnInteraction: false
								};
							}
							randomize(el);
							create_slider(el, {
								direction: 'horizontal',
								loop: false,
								autoHeight: true,
								lazy: {
									loadPrevNext: true
								},
								autoplay: autoplay_int,
								pagination: {
									el: '.swiper-pagination-' + el.getAttribute('data-random'),
									clickable: true,
									type: pagination_type
								},
								navigation: {
									nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
									prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
								},
								on: {
									slideChangeTransitionStart: function (swiper) {
										if (swiper.realIndex > 0) {
											swiper.$el[0].parentNode.classList.add('changed');
										} else {
											swiper.$el[0].parentNode.classList.remove('changed');
										}
										if (swiper.realIndex + 1 === total_sl) {
											swiper.$el[0].parentNode.classList.add('last-slide-active');
										} else {
											swiper.$el[0].parentNode.classList.remove('last-slide-active');
										}
									}
								}
							});
						});
					}

          window.addEventListener("listTestimonialsSlider", function(event) {
  					list_testimonials = document.querySelectorAll('.l4ts:not(.s4wi)');
            if (list_testimonials.length) {
  						Array.from(list_testimonials).forEach(function (el) {
  							var ln = [1, 2, 3],
  								pagination_type = 'bullets',
  								autoplay_int = false,
  								total_sl = el.children.length,
  								options;
							if (el.classList.contains('wide') || el.classList.contains('w100')) {
  								ln = [1, 1, 1];
  							}
							if (el.classList.contains('w50')) {
								ln = [1, 2, 2];
							}
  							if (el.classList.contains('slider-fraction')) {
  								pagination_type = 'fraction';
  							}
  							if (el.getAttribute('data-autoplay')) {
  								autoplay_int = {
  									delay: parseFloat(el.getAttribute('data-autoplay')),
									pauseOnMouseEnter: true,
									disableOnInteraction: false
  								};
  							}
  							randomize(el);
  							options = {
  								direction: 'horizontal',
  								loop: true,
  								autoHeight: true,
  								spaceBetween: 16,
  								slidesPerView: ln,
  								slidesPerGroup: ln,
  								autoplay: autoplay_int,
  								pagination: {
  									el: '.swiper-pagination-' + el.getAttribute('data-random'),
  									clickable: true,
  									type: pagination_type
  								},
  								navigation: {
  									nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
  									prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
  								},
  								on: {
  									slideChangeTransitionStart: function (swiper) {
  										if (swiper.realIndex > 0) {
  											swiper.$el[0].parentNode.classList.add('changed');
  										} else {
  											swiper.$el[0].parentNode.classList.remove('changed');
  										}
  										if (swiper.realIndex + 1 === total_sl) {
  											swiper.$el[0].parentNode.classList.add('last-slide-active');
  										} else {
  											swiper.$el[0].parentNode.classList.remove('last-slide-active');
  										}
  									}
  								},
  								breakpoints: {
  									0: {
  										slidesPerView: ln[0],
  										slidesPerGroup: ln[0]
  									},
  									760: {
  										slidesPerView: ln[1],
  										slidesPerGroup: ln[1]
  									},
  									1000: {
  										slidesPerView: ln[2],
  										slidesPerGroup: ln[2]
  									}
  								}
  							};
  							if (el.classList.contains('slider') && el.children.length > ln[2]) {
  								create_slider(el, options);
  							}
  							if (el.classList.contains('slider-mobile') && el.children.length > ln[0]) {
  								clone_with_class(el, 'mobile-only', 'mobile-hide');
  								if (el.nextElementSibling.classList.contains('mobile-only')) {
  									create_slider(el.nextElementSibling, options);
  								}
  							}
  						});
  					}
          });
          window.dispatchEvent(listTestimonialsSliderEvt);

          window.addEventListener("listStaticSlider", function(event) {
  					list_static = document.querySelectorAll('.l4st:not(.s4wi)');
  					if (list_static.length) {
  						Array.from(list_static).forEach(function (el) {
  							var pagination_type = 'bullets',
  								autoplay_int = false,
  								total_sl = el.children.length;
  							if (el.classList.contains('slider-fraction')) {
  								pagination_type = 'fraction';
  							}
  							if (el.getAttribute('data-autoplay')) {
  								autoplay_int = {
  									delay: parseFloat(el.getAttribute('data-autoplay')),
									pauseOnMouseEnter: true,
									disableOnInteraction: false
  								};
  							}
  							randomize(el);
  							clone_with_class(el, 'mobile-only', 'mobile-hide');
  							if (el.nextElementSibling.classList.contains('mobile-only')) {
  								create_slider(el.nextElementSibling, {
  									direction: 'horizontal',
  									loop: true,
  									autoHeight: true,
  									spaceBetween: 16,
  									autoplay: autoplay_int,
  									pagination: {
  										el: '.swiper-pagination-' + el.getAttribute('data-random'),
  										clickable: true,
  										type: pagination_type
  									},
  									navigation: {
  										nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
  										prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
  									},
  									on: {
  										slideChangeTransitionStart: function (swiper) {
  											if (swiper.realIndex > 0) {
  												swiper.$el[0].parentNode.classList.add('changed');
  											} else {
  												swiper.$el[0].parentNode.classList.remove('changed');
  											}
  											if (swiper.realIndex + 1 === total_sl) {
  												swiper.$el[0].parentNode.classList.add('last-slide-active');
  											} else {
  												swiper.$el[0].parentNode.classList.remove('last-slide-active');
  											}
  										}
  									}
  								});
  							}
  							/*if (el.classList.contains('slider')) {
  								randomize(el);
  							}*/
  						});
  					}
          });
          window.dispatchEvent(listStaticSliderEvt);

					window.addEventListener("listUspSlider", function(event) {
						list_usp = document.querySelectorAll('.l4us:not(.s4wi)');
						if (list_usp.length) {
							Array.from(list_usp).forEach(function (el) {
								if (!el.classList.contains('static')) {
									var options,
										autoplay_int = false,
										autowidth_int = 1,
										space_between;
									//pagination_type = 'bullets',
									//autoplay_int = false,
									//options;
									/*if (el.classList.contains('slider-fraction')) {
                                        pagination_type = 'fraction';
                                    }*/
									if (el.classList.contains('no-arrows')) {
										space_between = 16;
									} else {
										space_between = 44;
									}
									if (el.getAttribute('data-autoplay')) {
										autoplay_int = {
											delay: parseFloat(el.getAttribute('data-autoplay')),
											pauseOnMouseEnter: true,
											disableOnInteraction: false
										};
									}
									randomize(el);
									if (el.querySelectorAll('li').length === 1) {
										el.classList.remove('slider', 'slider-single');
									}
									if (el.closest('#nav-top') !== null && el.classList.contains('slider')) {
										el.classList.add('slider-in-header');
										if (!el.classList.contains('slider-single')) {
											autowidth_int = 'auto';
										}
									}
									options = {
										direction: 'horizontal',
										loop: true,
										pagination: false,
										autoplay: autoplay_int,
										slidesPerView: autowidth_int,
										spaceBetween: space_between,
										navigation: {
											nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
											prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
										},
										breakpoints: {
											0: {
												slidesPerView: 1
											},
											760: {
												slidesPerView: autowidth_int
											},
											1000: {
												spaceBetween: space_between
											},
											1100: {
												spaceBetween: 20
											}
										}
									};
									if (!el.classList.contains('slider')) {
										clone_with_class(el, 'l4us-mobile', 'mobile-hide');
										if (el.nextElementSibling.classList.contains('l4us-mobile')) {
											el.nextElementSibling.classList.remove('slider', 'slider-in-header');
											create_slider(el.nextElementSibling, options);
										}
									}
									if (el.classList.contains('slider')) {
										create_slider(el, options);
									}
								}
							});
						}
					});
					window.dispatchEvent(listUspSliderEvt);

					popup_a = document.getElementsByClassName('popup-a');
					if (popup_a.length) {
						Array.from(popup_a).forEach(function (el) {
							Array.from(el.getElementsByClassName('l4cl')).forEach(function (el) {
								el.classList.add('in-popup');
							});
						});
					}

					module_collection = document.getElementsByClassName('m6cl');
					if (module_collection.length) {
						Array.from(module_collection).forEach(function (el) {
							Array.from(el.querySelectorAll('.l4cl.slider:not(.w12, .w14, .w16, .w20, .w25, .w33, .w50)')).forEach(function (el) {
								el.classList.add('in-col');
							});
						});
					}

          window.addEventListener("listCollectionSlider", function(event) {
  					list_collection_slider = document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi)');
  					if (list_collection_slider.length) {
  						Array.from(list_collection_slider).forEach(function (el) {
                var items, hasImg = false,
										autoHeight = true,
								    loopMe = false;
  							if (typeof el.querySelectorAll('figure')[0] !== 'undefined') {
  								hasImg = true;
  								el.querySelectorAll('figure')[0].classList.add('first-image');
  							} else {
  								el.classList.add('no-img');
  							}
                if (el.classList.contains('slider-loop')) {
								  loopMe = true;
							  }
  							if (el.classList.contains('text-justify')) {
  								items = ['auto', 'auto', 'auto'];
  								autoHeight = false;
  							} else {
  								if (el.classList.contains('in-col')) {
  									items = [4, 4, 3];
  								} else if (el.classList.contains('w12')) {
  									items = [8, 6, 4];
  								} else if (el.classList.contains('w14')) {
  									items = [7, 6, 4];
  								} else if (el.classList.contains('w16')) {
  									items = [6, 5, 3];
  								} else if (el.classList.contains('w20')) {
  									items = [5, 5, 3];
  								} else if (el.classList.contains('w25')) {
  									items = [4, 4, 3];
  								} else if (el.classList.contains('w33')) {
  									items = [3, 3, 3];
  								} else if (el.classList.contains('w50')) {
  									items = [2, 2, 2];
  								} else {
  									items = [5, 5, 3];
  								}
  							}
  							randomize(el);
  							create_slider(el, {
  								direction: 'horizontal',
  								loop: loopMe,
								  autoHeight: autoHeight,
  								slidesPerView: items[0],
								focusableElements: 'input',
  								spaceBetween: 16,
									touchStartPreventDefault: false,
  								lazy: {
  									loadPrevNext: true
  								},
  								pagination: {
  									el: '.swiper-pagination-' + el.getAttribute('data-random'),
  									clickable: true
  								},
  								navigation: {
  									nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
  									prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
  								},
                  breakpoints: {
  									0: {
  										simulateTouch: false,
  										allowTouchMove: false
  									},
  									760: {
  										slidesPerView: items[2],
  										simulateTouch: true,
  										allowTouchMove: true
  									},
  									1000: {
  										slidesPerView: items[1],
  										simulateTouch: true,
  										allowTouchMove: true
  									},
  									1100: {
  										slidesPerView: items[0],
  										simulateTouch: true,
  										allowTouchMove: true
  									}
  								},
  								on: {
  									afterInit: function (swiper) {
                      if (hasImg === true) {
  											var h = swiper.$el[0].getElementsByClassName('first-image')[0].clientHeight + 'px';
  											swiper.navigation.prevEl.style.height = h;
  											swiper.navigation.nextEl.style.height = h;
  										}
  									},
  									resize: function (swiper) {
                      if (hasImg === true) {
  											var h = swiper.$el[0].getElementsByClassName('first-image')[0].clientHeight + 'px';
  											swiper.navigation.prevEl.style.height = h;
  											swiper.navigation.nextEl.style.height = h;
  										}
  									}
  								}
  							});
  						});
  					}
          });
          window.dispatchEvent(listCollectionSliderEvt);
          window.addEventListener("listProductSlider", function(event) {
  					list_product_slider = document.querySelectorAll('.l4pr:not(.s4wi)');
  					if (list_product_slider.length) {
  						Array.from(list_product_slider).forEach(function (el) {
  							//Array.from(list_product_slider).forEach(el => {
  							var mainSliderElement = el,
  								children = mainSliderElement.children,
  								qttChildren = children.length,
									total_sl = el.children.length,
  								mainSlider,
  								slides,
									firstModel = el.querySelectorAll('a > .model-3d:first-child model-viewer[poster]'),
                  position = el.dataset.featured_media_position - 1;
								Array.from(firstModel).forEach(function (em) {
									var staticPoster = document.createElement('img'),
									staticPosterWrapper = document.createElement('picture');
									staticPoster.setAttribute('src', em.getAttribute('poster'));
									staticPoster.setAttribute('data-src', em.getAttribute('poster'));
									staticPosterWrapper.prepend(staticPoster);
									staticPosterWrapper.classList.add('just-poster');
									if (em.hasAttribute('alt')) {
										staticPoster.setAttribute('alt', em.getAttribute('alt'));
									}
									em.closest('a').prepend(staticPosterWrapper);
								});
  							if (typeof children[5] !== 'undefined') {
  								children[4].classList.add('more');
  								append_url(children[4], '+' + qttChildren - 5, 'more');
  							}

  							// clone all slides before swiper uses them and change the DOM - used to create custom pagination
  							slides = mainSliderElement.cloneNode(true).children;

  							randomize(el);
  							mainSlider = create_slider(mainSliderElement, {
  								direction: 'horizontal',
  								loop: false,
  								autoHeight: true,
									preloadImages: false,
  								lazy: {
  									loadPrevNext: true
  								},
  								pagination: {
  									el: '.swiper-pagination-' + el.getAttribute('data-random'),
  									clickable: true,
  									renderBullet: function (index, className) {
  										var finalSpan = document.createElement("a"),
  											img_type,
  											add_class,
  											img,
  											divFlex,
  											moreLink,
  											icon,
  											span,
												a_thumb,
												a_thumb_img,
											a_thumb_pic,
											a_thumb_pic_class;
  										finalSpan.classList.add(className);
  										if (slides[index].hasAttribute('class')) {
  											add_class = slides[index].getAttribute('class');
                        if (add_class.includes('portrait')) {
  												finalSpan.classList.add('portrait');
  											}
  											if (add_class.includes('landscape')) {
  												finalSpan.classList.add('landscape');
  											}
											if (add_class.includes('cover')) {
												finalSpan.classList.add('cover');
												// finalSpan.classList.remove('landscape', 'portrait');
											}
  										}
  										if (slides[index].querySelector("picture")) {
  											img_type = 'picture';
  										} else {
  											img_type = 'img';
  										}
  										img = slides[index].querySelector(img_type);
											a_thumb = img.closest('a[data-gallery-thumb]');
											a_thumb_img = document.createElement('img');
											a_thumb_pic = document.createElement('picture');

											/*if (img) {
												finalSpan.appendChild(img);
											}*/
											if (a_thumb !== null) {
												a_thumb_img.setAttribute('src', a_thumb.getAttribute('data-gallery-thumb'));
												a_thumb_pic_class = a_thumb.querySelectorAll('picture[class]')[0];
												if (a_thumb_pic_class) {
													a_thumb_pic.classList.add(a_thumb_pic_class.getAttribute('class'));
												}
												a_thumb_img.setAttribute('alt', 'Thumbnail');
												a_thumb_img.setAttribute('width', '55');
												a_thumb_img.setAttribute('height', '55');
												a_thumb_img.setAttribute('loading', 'lazy');
												a_thumb_pic.appendChild(a_thumb_img);
												finalSpan.appendChild(a_thumb_pic);
											} else {
												if (img) {
													finalSpan.appendChild(img);
												}
	 										}

  										divFlex = document.createElement("span");
  										//divFlex.style = 'display: flex; height: 100%; width: 100%; position: absolute; top: 0; left: 0; align-items: center; justify-content: center; color: var(--secondary_bg);';

  										moreLink = slides[index].querySelector("a.more");
  										if (moreLink) {
  											span = document.createElement("span");
  											span.innerText = '+' + ((qttChildren - 1) - index).toString();

  											divFlex.appendChild(span);
  											finalSpan.classList.add('has-more');
  											if (slides[index].querySelectorAll('a[data-fancybox]')) {
  												Array.from(slides[index].querySelectorAll('a[data-fancybox]')).forEach(function (em) {
  													//finalSpan.setAttribute('data-fancybox',em.getAttribute('data-fancybox'));
  													finalSpan.setAttribute('href', em.getAttribute('href'));
  												});
  											}
  										}

  										icon = slides[index].querySelector("i[class^=icon-]");
  										if (icon) {
  											//icon.removeAttribute("aria-hidden");
  											//icon.style = "text-indent: 0;";

  											divFlex.appendChild(icon);
  										}

  										finalSpan.appendChild(divFlex);

  										return finalSpan.outerHTML;
  										// return '<span class="' + className + '">' + img.outerHTML + '</span>';
  									}
  								},
  								navigation: {
  									nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
  									prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
  								},
  								on: {
  									// "this" keyword within event handler always points to Swiper instance (from documentation https://swiperjs.com/swiper-api#events)
  									activeIndexChange: function () {
  										var activeIndex = this.activeIndex;
  										Array.from(this.el.parentNode.getElementsByClassName('custom-progressbar-inner')).forEach(function (el) {
  											el.style.width = 100 * (activeIndex + 1) / qttChildren + '%';
  										});
  									},
  									afterInit: function (swiper) {
  										// create progress bar
  										var progress_bar = createElementWithClass('div', 'custom-progressbar'),
													custom_fraction;
  										progress_bar.innerHTML = '<div class="custom-progressbar-inner" style="width:' + 100 / qttChildren + '%;"></div>';
  										swiper.el.appendChild(progress_bar);
  										Array.from(swiper.el.getElementsByClassName('label')).forEach(function (em) {
  											swiper.el.parentNode.appendChild(em);
  										});
											if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
												custom_fraction = swiper.el.parentNode.getElementsByClassName('swiper-custom-fraction')[0];
												custom_fraction.innerHTML = '<span class="swiper-pagination-current">1</span> / <span class="total-el">' + swiper.slides.length + '</span>';
											}
  										// click events
  										/*Array.from(swiperElement.parentNode.getElementsByClassName('swiper-pagination-bullet')).forEach(function (el) {
  											el.addEventListener('click', function (e) {
  												el.classList.add('show');
  											});
  										});*/
  										setTimeout(function () {
  											var h = swiper.height + 'px';
  											swiper.navigation.prevEl.style.height = h;
  											swiper.navigation.nextEl.style.height = h;
  										}, 300);
                      swiper.slideTo(position, 500);
  									},
  									slideChangeTransitionEnd: function (swiper) {
  										var h = swiper.height + 'px';
  										swiper.navigation.prevEl.style.height = h;
  										swiper.navigation.nextEl.style.height = h;
  									},
										slideChangeTransitionStart: function (swiper) {
											if (el.classList.contains('no-thumbs-mobile') || el.classList.contains('slider-fraction')) {
												var custom_fraction = swiper.el.parentNode.getElementsByClassName('swiper-pagination-current')[0];
												custom_fraction.innerHTML = swiper.realIndex + 1;
												if (swiper.realIndex > 0) {
													swiper.el.classList.add('changed');
												} else {
													swiper.el.classList.remove('changed');
												}
											}
											if (swiper.realIndex + 1 === total_sl) {
												swiper.el.classList.add('last-slide-active');
											} else {
												swiper.el.classList.remove('last-slide-active');
											}
										},
  									resize: function (swiper) {
  										var h = swiper.height + 'px';
  										swiper.navigation.prevEl.style.height = h;
  										swiper.navigation.nextEl.style.height = h;
  									}
  								}
  							});

  							data_update_product_slider = document.querySelectorAll('[data-l4pr-index]');
                if (data_update_product_slider.length) {
  								Array.from(data_update_product_slider).forEach(function (el) {
  									if (el.tagName.toLowerCase() === 'option') {
  										var em = el.parentNode;
  										em.addEventListener('change', function () {
  											var dx = em[em.selectedIndex].getAttribute('data-l4pr-index');
  											if (dx !== null) {
  												mainSlider.slideTo(dx);
  											}
  										});
  									} else {
  										el.addEventListener('click', function (e) {
  											mainSlider.slideTo(el.getAttribute('data-l4pr-index'));
  											if (el.tagName.toLowerCase() === 'a') {
  												e.preventDefault();
  											}
  										});
  									}
  								});
  							}
  						});
  					}
          });
          window.dispatchEvent(listProductSliderEvt);
				}
			},
		};

	setTimeout(function () {
		Default.utils.start();
		Default.utils.top();
		Default.utils.links();
		Default.utils.mails();
		Default.utils.forms();
		Default.utils.footer();
		Default.utils.tabs();
		Default.utils.swipers();
		Default.utils.ratings();
    Default.utils.backgrounds();
		Default.utils.mobile();
		Default.utils.done();
	}, 0);
});

/*!*/
window.addEventListener("createCols", function(event) {
  var servicePageElement = document.querySelector('[id$="page-service-info-blocks"]');
  if (servicePageElement != null) {
	  if (servicePageElement.parentElement.classList.contains('cols')) {
		  var parent = servicePageElement.parentElement;
		  var article = servicePageElement.parentElement.querySelector('article.w64.t55');
		  if (article) { article.replaceWith(...article.childNodes); }
		  parent.replaceWith(...parent.childNodes);
	  }

	  var anySiblingFound = false;
	  var wrapper = document.createElement('div');
	  wrapper.classList.add('cols');
	  var wrapperInner = document.createElement('article');
	  wrapperInner.classList.add('w64','t55');
	  wrapper.appendChild(wrapperInner);
	  var possibleSiblings = ['shopify-section-page-service-menu', 'shopify-section-faq', 'shopify-section-contact-form', 'shopify-section-google-maps'];

	  var findSibling = function() {
		var prevSibling = servicePageElement.previousSibling;
		if (prevSibling) {
		  var correctSiblingFound = false;
		  for (var i = 0; i < possibleSiblings.length; i++) {
			if (prevSibling.classList.contains(possibleSiblings[i])) {
			  correctSiblingFound = true;
			  anySiblingFound = true;
			  prevSibling.classList.add('w64','t55')
			  wrapperInner.appendChild(prevSibling);
			}
		  }
		  if (correctSiblingFound) {
			findSibling();
		  } else {
			for (var i = 1; i < wrapperInner.childNodes.length; i++){
			  wrapperInner.insertBefore(wrapperInner.childNodes[i], wrapperInner.firstChild);
			}
			if (anySiblingFound) {
			  servicePageElement.parentNode.insertBefore(wrapper, servicePageElement);
			  wrapper.appendChild(servicePageElement);
			}
		  }
		}
	  }
	  findSibling();
  }
});
window.dispatchEvent(createColsEvt);

window.addEventListener("showAlert", function(event) {
	var messageText = event.detail.message,
			messageType = event.detail.type,
			messageHeader = event.detail.header ? event.detail.header : false,
      messageOrigin = event.detail.origin ? 'message-' + event.detail.origin : false,
			messageColor = '';
	switch(messageType) {
	  case "success":
	    messageColor = 'lime';
			if (!messageHeader) { messageHeader = 'Success!'; }
	    break;
	  case "info":
	    messageColor = 'pine';
			if (!messageHeader) { messageHeader = 'Info'; }
	    break;
	  case "error":
	   	messageColor = 'rose';
			if (!messageHeader) { messageHeader = 'Error...'; }
			break;
		default:
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = ''; }
	}
  	var message = '<li class="overlay-'+ messageColor +' '+ messageOrigin +'"><i aria-hidden="true" class="icon-'+ messageType +'"></i><p class="strong">'+ messageHeader +'</p><p>'+ messageText +'</p><a href="./" class="close">Close</a></li>';
	var list_alerts = document.querySelector('.l4al:not(.inline)');

	if (list_alerts === null) {
		list_alerts = document.createElement("ul");
		list_alerts.classList.add('l4al');
		if (document.getElementById('shopify-section-footer')) {
			document.getElementById('shopify-section-footer').parentNode.insertBefore(list_alerts, document.getElementById('shopify-section-footer').nextSibling);
		} else {
			document.getElementById('content').parentNode.insertBefore(list_alerts, document.getElementById('content').nextSibling);
		}
	}
  if ((messageOrigin && list_alerts.getElementsByClassName(messageOrigin).length == 0) || !messageOrigin) { // Prevent double messages (multiple of the same forms are being triggered when posted in shopfiy)
    list_alerts.innerHTML += message;
  }
  if (typeof alertsEvt != 'undefined') { window.dispatchEvent(alertsEvt); }
}, false);

function scrollToTargetAdjusted(el) {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	el.scrollIntoView({
		block: 'center'
	});
}
let loadMoreItemClicked = localStorage.getItem('loadMoreItemClicked');
if (loadMoreItemClicked != null) {
	let el = document.querySelector('#collection > li > figure > a[href="'+ loadMoreItemClicked +'"], .m6cl .results > div a[href="'+ loadMoreItemClicked +'"], .m6cl .results > .l4ne a[href="'+ loadMoreItemClicked +'"]'),
		url = window.location.href;
	if (el && !url.includes(loadMoreItemClicked)) {
		scrollToTargetAdjusted(el);
		localStorage.removeItem('loadMoreItemClicked');
	} else if (!url.includes(loadMoreItemClicked)) {
		localStorage.removeItem('loadMoreItemClicked');
	}
}